export const fixed_companies = [
    {
        "name": "Nestle",
        "foragerId": 259
    },
    {
        "name": "Abbott Laboratories",
        "foragerId": 407
    },
    {
        "name": "PepsiCo",
        "foragerId": 281
    },
    {
        "name": "Cargill Pet Food",
        "foragerId": 1155
    },
    {
        "name": "Mondelez",
        "foragerId": 334
    },
    {
        "name": "Danone",
        "foragerId": 853
    },
    {
        "name": "Mars",
        "foragerId": 356
    },
    {
        "name": "DuPont Nutritional Food Ingredients",
        "foragerId": 789
    },
    {
        "name": "Haleon Pharmaceutical",
        "foragerId": 58817164
    },
    {
        "name": "Beiersdorf",
        "foragerId": 135754
    },
    {
        "name": "United Foods",
        "foragerId": 22423
    },
    {
        "name": "Bühler Food Manufacturing / Bu Le Food Manufacturing",
        "foragerId": 194080
    },
    {
        "name": "Royal Canin Foods",
        "foragerId": 11555
    },
    {
        "name": "Royal Canin",
        "foragerId": 11555
    },
    {
        "name": "Jinhai Yili Dairy",
        "foragerId": 151558
    },
    {
        "name": "Inner Mongolia Yili Industrial Group",
        "foragerId": 151558
    },
    {
        "name": "Yili Dairy",
        "foragerId": 151558
    },
    {
        "name": "Yili Industry Group",
        "foragerId": 151558
    },
    {
        "name": "Nissin Foods",
        "foragerId": 89773
    },
    {
        "name": "Petsense Food",
        "foragerId": 89866
    },
    {
        "name": "Glico Food",
        "foragerId": 14948144
    },
    {
        "name": "Botora Nutritional Foods",
        "foragerId": 1085394
    },
    {
        "name": "Healthlife Nutrition",
        "foragerId": 5798645
    },
    {
        "name": "Amarin",
        "foragerId": 119984
    },
    {
        "name": "Naturex",
        "foragerId": 1955844
    },
    {
        "name": "Pigeon Baby Product",
        "foragerId": 22761735
    },
    {
        "name": "Shanghai Jahwa United",
        "foragerId": 15265652
    }
]
